import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE } from '../config';
import { useLanguage } from '../LanguageContext';

const Health = () => {
    const { t, isRtl } = useLanguage();
    const [backendStatus, setBackendStatus] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`${API_BASE}/health`)
            .then(res => setBackendStatus(res.data))
            .catch(err => setBackendStatus({ status: 'error', error: err.message }))
            .finally(() => setLoading(false));
    }, []);

    const cardStyle = {
        background: '#fff',
        borderRadius: 12,
        padding: 24,
        boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
        maxWidth: 500,
        width: '100%',
        border: '1px solid #eef0f2'
    };

    const statusBadge = (ok) => (
        <span style={{
            padding: '4px 8px',
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 700,
            background: ok ? '#e6f4ea' : '#fce8e6',
            color: ok ? '#1e8e3e' : '#d93025',
            [isRtl ? 'marginRight' : 'marginLeft']: 8
        }}>
            {ok ? t.healthy : t.error_u}
        </span>
    );

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: 24,
            background: '#f6f6f7',
            fontFamily: "'Outfit', sans-serif"
        }}>
            <div style={{ ...cardStyle, direction: isRtl ? 'rtl' : 'ltr', textAlign: isRtl ? 'right' : 'left' }}>
                <h1 style={{ margin: '0 0 20px 0', fontSize: 24, fontWeight: 700 }}>{t.system_health}</h1>

                <div style={{ marginBottom: 20 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8, flexDirection: isRtl ? 'row-reverse' : 'row' }}>
                        <span style={{ fontWeight: 600 }}>{t.frontend_service}:</span>
                        {statusBadge(true)}
                    </div>
                    <div style={{ fontSize: 13, color: '#6d7175' }}>{t.frontend_running}</div>
                </div>

                <div style={{ borderTop: '1px solid #eef0f2', paddingTop: 20 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8, flexDirection: isRtl ? 'row-reverse' : 'row' }}>
                        <span style={{ fontWeight: 600 }}>{t.backend_api}:</span>
                        {loading ? <span style={{ [isRtl ? 'marginRight' : 'marginLeft']: 8, fontSize: 12 }}>{t.checking}</span> : statusBadge(backendStatus?.status === 'ok')}
                    </div>

                    {backendStatus && !loading && (
                        <div style={{ background: '#f8f9fa', padding: 12, borderRadius: 8, marginTop: 12, fontSize: 12, fontFamily: 'monospace' }}>
                            <pre style={{ margin: 0 }}>{JSON.stringify(backendStatus, null, 2)}</pre>
                        </div>
                    )}
                </div>

                <div style={{ marginTop: 24, textAlign: 'center' }}>
                    <a href="/" style={{ fontSize: 13, color: '#1976d2', fontWeight: 600, textDecoration: 'none' }}>{t.return_to_app}</a>
                </div>
            </div>
            <div style={{ marginTop: 20, fontSize: 12, color: '#919191' }}>{t.status_monitor}</div>
        </div>
    );
};

export default Health;
